import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupPhone = () => {
  const { t } = useTranslation();
  return {
    phone_number: Yup.string().required(
      t("validation.required", {
        phone_number: t("page.phoneNumber"),
      })
    ),
  };
};
